import axios from "./apiClient";
import { jwtDecode } from "jwt-decode";
import { SALENG_SHOP_API_PROD } from "./../config";

const SALENG_SHOP_API = SALENG_SHOP_API_PROD;

const getAccessToken = () => {
  const token = localStorage.getItem("accessToken");
  if (!token) return null;

  try {
    return JSON.parse(token);
  } catch {
    return token;
  }
};

const decodeToken = () => {
  const token = getAccessToken();
  if (!token) return null;
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
};

const getIds = () => {
  const decoded = decodeToken();
  return {
    accessToken: getAccessToken(),
    userId: decoded?.id ?? null,
    shopId: decoded?.shopId ?? null,
    branchId: localStorage.getItem("branchId"),
    isMain: decoded?.isMain ?? false,
  };
};

export const createCustomer = (payload) => {
  const { shopId, branchId } = getIds();

  return axios.post(
    `${SALENG_SHOP_API}/customer`,
    { ...payload, shopId: shopId, branchId: branchId, customerBranchId: payload.customerBranchId ?? null },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

export const updateCustomer = (payload, id, options = {}) => {
  const { shopId, branchId } = getIds();
  const { includeMeta = true } = options;

  const body = includeMeta
    ? { ...payload, shopId: shopId, branchId: branchId }
    : { ...payload };

  return axios.patch(
    `${SALENG_SHOP_API}/customer/${id}`,
    body,
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

export const upload = (formData) => {
  return axios.post(`${SALENG_SHOP_API}/files`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getCustomers = (customerType) => {
  const { shopId, branchId } = getIds();

  return axios.get(
    `${SALENG_SHOP_API}/customer`,
    {
      params: {
        shopId,
        branchId,
        customerType,
      },
    },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

export const getCustomersByShop = () => {
  const { shopId } = getIds();
  return axios.get(`${SALENG_SHOP_API}/customer`, {
    params: { shopId },
    headers: { "Content-Type": "application/json" },
  });
};

export const getCustomersList = () => {
  const { shopId, branchId } = getIds();

  return axios.get(
    `${SALENG_SHOP_API}/customer/list`,
    {
      params: {
        shopId: shopId,
        branchId: branchId,
      },
    },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

export const getCustomersById = (id) => {
  return axios.get(
    `${SALENG_SHOP_API}/customer/${id}`,
    {},
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

export const getGroup = () => {
  const { shopId } = getIds();

  return axios.get(
    `${SALENG_SHOP_API}/customer/groups`,
    {
      params: {
        shopId: shopId,
      },
    },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

export const addGroup = (payload) => {
  const { shopId, branchId } = getIds();

  return axios.post(
    `${SALENG_SHOP_API}/customer/group`,
    { ...payload, shopId: shopId, branchId: branchId },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

export const getCustomerByGroup = (id) => {
  return axios.get(
    `${SALENG_SHOP_API}/customer/groups/${id}`,
    {},
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

export const addCustomerToGroup = (payload) => {
  return axios.post(
    `${SALENG_SHOP_API}/customer/group/add-customer`,
    { ...payload },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

export const updateCustomeGroup = (payload) => {
  return axios.post(
    `${SALENG_SHOP_API}/customer/group/remove-customer`,
    { ...payload },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};
